import React from "react";
import { StarIcon, UserIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/testimonials";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-261" data-mp="1ru392vr9u0rc">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-262" data-mp="1muibaonu7yg7" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-263" data-mp="1duv6rtztacix">
      <SectionHeading title="What other students are saying" subtitle="More students are using Reflexology Session Blueprint™ to organize their practice." data-id="element-264" data-mp="18wtqfgtrsrb5" />
      <div className="mt-6 flex items-center justify-center gap-3" data-id="element-265" data-mp="13ztjz4t0dmji">
        <Stars data-id="element-266" data-mp="339jkpzo1w2j2" />
        <span className="font-serif text-2xl font-bold text-ink" data-id="element-267" data-mp="33a1p5jkv9n22">4.9/5</span>
      </div>

      <ul className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-268" data-mp="2yc9lxterueik">
        {testimonials.map((t, i) => <li key={i} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-ink/10" data-id="element-269" data-mp="1tbzw78dr7h4n" data-mpi={i}>
            <Stars data-id="element-270" data-mp="1y6nc4iuoz37m" />
            <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-ink/85" data-id="element-271" data-mp="1jbh6hwzid6et">“{t.quote}”</blockquote>
            <div className="mt-6 flex items-center gap-3 border-t border-ink/10 pt-5" data-id="element-272" data-mp="1oa0r9u2d8c5l">
              {t.photo ? <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand-light" data-id="element-273" data-mp="2bzv62h68wash" /> : <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-brand-light text-brand" aria-hidden="true" data-id="element-274" data-mp="2h12b48h06vvg">
                  <UserIcon className="h-7 w-7" data-id="element-275" data-mp="278wntc1p52ml" />
                </span>}
              <div data-id="element-276" data-mp="2uz90t1bstpk1">
                <p className="font-bold text-ink" data-id="element-277" data-mp="2uyqzhqaa4l59">{t.name}</p>
                <p className="text-sm text-ink/70" data-id="element-278" data-mp="2zppe8lfmdb6e">
                  <span aria-hidden="true" data-id="element-279" data-mp="2zqha7xd4pax7">{t.flag}</span> {t.country}
                </p>
              </div>
            </div>
          </li>)}
      </ul>

      <CTAButton label="Yes! I want to practice with a clear system" className="mt-12" data-id="element-280" data-mp="34muuvhm5ruhx" />
    </section>;
}